// src/pages/admin/{Notice1FormForm.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import NoticeTransformPartnershipToCompany_TH from "../../forms/anounce/NoticeTransformPartnershipToCompany_TH/NoticeTransformPartnershipToCompany_TH";

function NoticeTransformPartnershipToCompany_THPage() {
  return (
    <FormWrapper
      title="ประกาศแปรสภาพห้างหุ้นส่วนจำกัดเป็นบริษัทจำกัด"
      FormComponent={NoticeTransformPartnershipToCompany_TH}
      formKey="NoticeTransformPartnershipToCompany_TH" // key ไว้แยกชื่อไฟล์รูป/เก็บ localStorage ถ้ามี
    />
  );
}

export default NoticeTransformPartnershipToCompany_THPage;
